var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSignGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "12px",
    viewBox: "0 0 11 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AB34B749-C78E-4865-8746-A1DCAF15620C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timesheet-Consultant",
    transform: "translate(-846.000000, -330.000000)",
    fill: "#6DCC56",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paid2",
    transform: "translate(837.000000, 324.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "DollarSignGreen",
    points: "12.4186047 16.8837209 12.4186047 18 15.627907 18 15.627907 16.8837209 19.0465116 16.8837209 19.0465116 11.8604651 12.4186047 10.255814 12.4186047 9.76744186 15.7674419 9.76744186 15.7674419 10.4651163 19.0465116 10.4651163 19.0465116 7.11627907 15.627907 7.11627907 15.627907 6 12.4186047 6 12.4186047 7.11627907 9 7.11627907 9 12.0697674 15.627907 13.6744186 15.627907 14.2325581 12.2790698 14.2325581 12.2790698 13.5348837 9 13.5348837 9 16.8837209"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSignGreen);
export default __webpack_public_path__ + "static/media/dollar-sign-green.025f6c093a109431836f618fac0e54ad.svg";
export { ForwardRef as ReactComponent };